import { Outlet } from "react-router-dom";

// import "../styles/frontend/language.css";
import "@/styles/frontend/v3.scss";
import "@/styles/frontend/_media.scss";
// import "@/styles/common/common.css";
// import "@/styles/frontend/dharmesh.css";
import Header from "@/modules/frontend/components/Header";
import Footer from "@/modules/frontend/components/Footer";

const FrontLayout = (props) => {
    return (<div className="outer-pages front-end-style">
        <Header />
        <main>
            <Outlet context={props} /> { /** Dynamic front-end pages render */}
        </main>
        <Footer />
    </div >)
}

export default FrontLayout;